export const EVENT_PROCEDURES_LIL_LIST_ID = "eventProceduresLilList";
export const ATTRIBUTES = [
  {
    id: "select",
    title: "",
    type: "BOOLEAN",
    filterable: false,
    sortable: false,
    searchable: false
  },
  {
    id: "title",
    title: "Title",
    type: "STRING",
    filterable: false
  }
];
export const listElements = {
  defaultLayout: {
    entityTableId: EVENT_PROCEDURES_LIL_LIST_ID,
    defaultPageSize: 10,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: ["select", "title"],
    defaultColumnOrder: ["select", "title"]
  }
};
export const deserializeEventProcedures = ({ page, per_page, total, count, event_procedures }) => ({
  attributes: ATTRIBUTES,
  list: event_procedures.map((procedure) => ({
    select: false,
    ...procedure
  })),
  pagination: { total, page, per_page, count }
});
